import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { faExclamationTriangle } from "@fortawesome/pro-light-svg-icons";

@Component({
    selector: "error-dialog",
    templateUrl: "error.component.html",
    styleUrls: ["./error.component.scss"],
    standalone: false
})
export class ErrorDialogComponent {
  message: string = "";
  detail: string = "";
  type: string = "";
  faExclamationTriangle = faExclamationTriangle;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ErrorDialogComponent>
  ) {
    if (data) {
      this.message = data.message || this.message;
      this.detail = data.detail || this.detail;
      this.type = data.type || "system";
    }
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  onConfirmClick(): void {
    this.dialogRef.close(true);
  }
}
